import CommentBubble from "./CommentBubble";
import type { CommentAttachmentType, CommentBubbleProps } from "./types";

export type { CommentAttachmentType, CommentBubbleProps };
export default CommentBubble;
